import React from 'react';
import PropTypes from 'prop-types';
import './Features.css';

const Features = ({ property }) => {
    const { name, disclosure, street_address, city, state_long_name, state, zip_code, features } = property;

    return (
        <section className='section section-features'>
            <div className='container'>
                <div className='columns is-multiline'>
                    <div className='column is-10 is-offset-1'>
                        <div className='border-left-yellow'>
                            <h1 className='big-title'>
                                {name}
                            </h1>
                            <h1 className='property-address'>
                                <span className='street-address'>{street_address}&nbsp;</span>
                                <span className='city-state-zip'>{city}, {state_long_name || state} {zip_code}</span>
                            </h1>
                            {disclosure && <h6 className='property-disclosure'>
                                <span>{disclosure}</span>
                            </h6>}
                        </div>
                        {features && features.length > 0 ?
                            <div className='features-wrapper'>
                                <div className='columns is-mobile is-multiline is-gapless'>
                                    {features.map((item, index) => {
                                        return (
                                            index < 12 ?
                                                <div key={index} className='column is-6-mobile is-4-tablet is-4-desktop'>
                                                    <div className='feature-wrapper'>
                                                        <h4 className='feature-name'>{item.feature.feature_name}</h4>
                                                        <p className='feature-description'>{item.feature.feature_description}</p>
                                                    </div>
                                                </div> : null
                                        );
                                    })}
                                </div>
                            </div>
                            : null}
                    </div>
                </div>
            </div>
        </section>

    );
};

Features.propTypes = {
    property: PropTypes.shape({
        name: PropTypes.string.isRequired,
        street_address: PropTypes.string.isRequired,
        city: PropTypes.string.isRequired,
        state_long_name: PropTypes.string,
        state: PropTypes.string,
        disclosure: PropTypes.string,
        zip_code: PropTypes.string,
        features: PropTypes.array,
    }).isRequired,
};

export default Features;
